import type { AnyNode } from "@pdfking/forms"
import { FailAtPath } from "@pdfking/forms"

import type { ComponentFailure } from "#internal"

/**
 * Apply nested failures onto the `component_array` node — each path is relative
 * to it (e.g. `[ci, "job_array", ji, "print_mode"]`). Shared by the
 * component/job-level validators so each only computes its violations.
 *
 * A validator's `results` exposes children as `ValidationResult` (value/error);
 * placing a nested error needs the underlying node, so `component_array` is
 * widened to its `AnyNode` form here — the single spot that reaches into node
 * internals.
 */
export const ApplyComponentFailures = <R extends { component_array: unknown }>(
  results: R,
  failures: ComponentFailure[]
): R => {
  if (failures.length === 0) return results

  const component_array = failures.reduce<AnyNode>(
    (node, failure) => FailAtPath(node, failure.path, failure.error),
    results.component_array as AnyNode
  )

  return { ...results, component_array }
}
